import * as React from "react";
const SvgSafeReport = (props) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 16, cy: 16, r: 8, fill: "#1A1A1A", style: {
  fill: "#1A1A1A",
  fill: "color(display-p3 0.1020 0.1020 0.1020)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M16.0801 13.6836V16.1522", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.44, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M16.0801 18.6211H16.0874", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.44, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgSafeReport;
